var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h5-page" },
    [
      _c(
        "div",
        { staticClass: "h5-header" },
        [
          _c("a-icon", {
            attrs: { type: "left" },
            on: { click: () => _vm.$router.back() },
          }),
          _c("span", [_vm._v("订单详情")]),
          _c("span"),
        ],
        1
      ),
      _c("div", { staticClass: "h5-body" }, [
        _c("div", { staticClass: "h5-card" }, [
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("单据号")]),
            _c("span", [_vm._v(_vm._s(_vm.detail.billNo))]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("伙伴")]),
            _c("span", [_vm._v(_vm._s(_vm.detail.partnerName || "-"))]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("类型")]),
            _c("span", [_vm._v(_vm._s(_vm.detail.subType))]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("金额")]),
            _c("span", [
              _vm._v("￥" + _vm._s(_vm.formatAmount(_vm.detail.totalPrice))),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("时间")]),
            _c("span", [_vm._v(_vm._s(_vm.detail.operTime || "-"))]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "label" }, [_vm._v("当前状态")]),
            _c("span", { staticClass: "cur-status" }, [
              _vm._v(_vm._s(_vm.detail.orderStatusName)),
            ]),
          ]),
          _vm.canPay
            ? _c(
                "div",
                { staticClass: "pay-area" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        block: "",
                        loading: _vm.paying,
                      },
                      on: { click: _vm.handlePay },
                    },
                    [_vm._v("去支付")]
                  ),
                  _c("div", { staticClass: "pay-tip" }, [
                    _vm._v("在线支付货款给供应商，支付后订单状态更新为已付款"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "h5-card" }, [
          _c("div", { staticClass: "card-title" }, [_vm._v("状态时间线")]),
          _c(
            "div",
            { staticClass: "timeline" },
            _vm._l(_vm.timelineNodes, function (node, index) {
              return _c("div", { key: index, staticClass: "tl-node" }, [
                _c("div", {
                  staticClass: "tl-dot",
                  class: { on: index === _vm.timelineNodes.length - 1 },
                }),
                index < _vm.timelineNodes.length - 1
                  ? _c("div", { staticClass: "tl-line" })
                  : _vm._e(),
                _c("div", { staticClass: "tl-content" }, [
                  _c("div", { staticClass: "tl-head" }, [
                    _c("span", { staticClass: "tl-status" }, [
                      _vm._v(_vm._s(node.statusName)),
                    ]),
                    _c("span", { staticClass: "tl-time" }, [
                      _vm._v(_vm._s(node.time)),
                    ]),
                  ]),
                  node.remark
                    ? _c("div", { staticClass: "tl-remark" }, [
                        _vm._v(_vm._s(node.remark)),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
            0
          ),
        ]),
        _c(
          "div",
          { staticClass: "h5-card" },
          [
            _c("div", { staticClass: "card-title" }, [_vm._v("商品明细")]),
            _vm._m(0),
            _vm._l(_vm.detail.items, function (item, index) {
              return _c("div", { key: index, staticClass: "item-row" }, [
                _c("span", { staticClass: "item-name" }, [
                  _vm._v(_vm._s(item.materialName || "-")),
                ]),
                _c("span", [
                  _vm._v(_vm._s(item.operNumber) + _vm._s(item.unit || "")),
                ]),
                _c("span", [_vm._v(_vm._s(item.unitPrice))]),
                _c("span", [_vm._v(_vm._s(item.allPrice))]),
              ])
            }),
            !_vm.detail.items || _vm.detail.items.length === 0
              ? _c("div", { staticClass: "empty" }, [_vm._v("暂无明细")])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("h5-tab-bar", { attrs: { active: "orders" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-row item-head" }, [
      _c("span", [_vm._v("商品")]),
      _c("span", [_vm._v("数量")]),
      _c("span", [_vm._v("单价")]),
      _c("span", [_vm._v("金额")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }